module.exports = __webpack_public_path__ + "bj.73ca17044cd6c58dd9d6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bj.svg
// module chunks = styles